import { FilterChoice } from '../../common/components/SearchHeader/types/FilterChoice';

const LOW_RESULTS_THRESHOLD = 10;

export const isExtendedSearchPossible = (totalCount: number | undefined, filters: FilterChoice) =>
  (totalCount ?? 0) <= LOW_RESULTS_THRESHOLD && Boolean(filters.onlineAppointments);
